// Mock property data for STARKKE IMMOBILIER
// Bilingual fields stored as { fr, en }

const img = (id, w = 1200) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const HERO_IMAGES = {
  interior: img('1788661687125-90bba579d6c2', 1900),
  interior2: img('1643966391593-3c18419d9ae8', 1600),
  parisGolden: img('1526821799652-2dc51675628e', 1600),
  parisGolden2: img('1564420179789-ede909db4882', 1600),
  geneva: img('1663616842575-c24b40700e0a', 1600),
  geneva2: img('1667042941761-2839fabc419d', 1600),
};

export const CATEGORIES = [
  {
    slug: 'hotels',
    label: { fr: 'Hôtels', en: 'Hotels', es: 'Hoteles', zh: '酒店', de: 'Hotels' },
    tagline: {
      fr: 'Actifs hôteliers de prestige', en: 'Prestige hospitality assets',
      es: 'Activos hoteleros de prestigio', zh: '尊贵酒店资产', de: 'Prestige-Hotelanlagen',
    },
    desc: {
      fr: "Hôtels de charme, palaces et établissements d'exception à la transaction ou à l'investissement.",
      en: 'Boutique hotels, palaces and exceptional establishments for acquisition or investment.',
      es: 'Hoteles con encanto, palacios y establecimientos excepcionales para transacción o inversión.',
      zh: '精品酒店、豪华宫殿及卓越物业，供收购或投资。',
      de: 'Boutique-Hotels, Paläste und aussergewöhnliche Häuser zum Erwerb oder als Investition.',
    },
    cover: img('1683290844875-0eee4089069a', 1400),
  },
  {
    slug: 'immeubles',
    label: { fr: 'Immeubles', en: 'Buildings', es: 'Edificios', zh: '楼宇', de: 'Gebäude' },
    tagline: {
      fr: 'Immeubles de rapport & pied dans la ville', en: 'Income buildings & city landmarks',
      es: 'Edificios de renta y presencia urbana', zh: '收益型楼宇与城市地标', de: 'Renditeobjekte & Stadtlagen',
    },
    desc: {
      fr: 'Immeubles haussmanniens, immeubles de rapport et ensembles urbains à fort potentiel.',
      en: 'Haussmann buildings, income properties and urban ensembles with strong potential.',
      es: 'Edificios haussmanianos, inmuebles de renta y conjuntos urbanos de gran potencial.',
      zh: '奥斯曼风格建筑、收益型物业及高潜力城市综合体。',
      de: 'Haussmann-Gebäude, Renditeobjekte und städtische Ensembles mit hohem Potenzial.',
    },
    cover: img('1614349214089-e969a07e033b', 1400),
  },
  {
    slug: 'appartements',
    label: { fr: 'Appartements & Maisons', en: 'Apartments & Houses', es: 'Pisos y Casas', zh: '公寓与住宅', de: 'Wohnungen & Häuser' },
    tagline: {
      fr: 'Résidentiel de standing', en: 'Fine residential living',
      es: 'Residencial de categoría', zh: '优质住宅', de: 'Gehobenes Wohnen',
    },
    desc: {
      fr: 'Appartements et maisons de caractère, du pied-à-terre urbain à la demeure familiale.',
      en: 'Characterful apartments and houses, from urban pied-à-terre to family homes.',
      es: 'Pisos y casas con carácter, del pied-à-terre urbano a la residencia familiar.',
      zh: '独具个性的公寓与住宅，从城市居所到家庭宅邸。',
      de: 'Charaktervolle Wohnungen und Häuser, vom städtischen Pied-à-terre bis zum Familiensitz.',
    },
    cover: img('1600596542815-ffad4c1539a9', 1400),
  },
  {
    slug: 'exception',
    label: { fr: 'Murs et fonds de commerce', en: 'Commercial Walls & Businesses', es: 'Muros y fondos de comercio', zh: '商业物业与营业资产', de: 'Geschäftshäuser & Betriebe' },
    tagline: {
      fr: 'Emplacements & murs commerciaux', en: 'Prime retail & business assets',
      es: 'Ubicaciones y locales comerciales', zh: '优质商铺与营业资产', de: 'Toplagen & Gewerbeobjekte',
    },
    desc: {
      fr: 'Locaux commerciaux, murs et fonds de commerce sur des emplacements de premier plan.',
      en: 'Retail units, commercial walls and going-concern businesses in prime locations.',
      es: 'Locales comerciales, muros y fondos de comercio en ubicaciones de primer nivel.',
      zh: '位于一流地段的商铺、商业物业及营业资产。',
      de: 'Gewerberäume, Geschäftshäuser und Betriebe in erstklassigen Lagen.',
    },
    cover: img('1441986300917-64674bd600d8', 1400),
  },
  {
    slug: 'liquidation',
    label: { fr: 'Enchères / Judiciaire', en: 'Auctions / Judicial', es: 'Subastas / Judicial', zh: '拍卖 / 司法', de: 'Auktionen / Justiz' },
    tagline: {
      fr: "Opportunités d'acquisition en procédure", en: 'Distressed acquisition opportunities',
      es: 'Oportunidades de adquisición en procedimiento', zh: '程序中的收购机会', de: 'Erwerbschancen im Verfahren',
    },
    desc: {
      fr: "Actifs immobiliers issus de procédures collectives — des opportunités réservées aux investisseurs avertis.",
      en: 'Real estate assets from insolvency procedures — opportunities reserved for informed investors.',
      es: 'Activos inmobiliarios procedentes de procedimientos concursales — oportunidades para inversores expertos.',
      zh: '源自破产程序的房地产资产——为资深投资者保留的机会。',
      de: 'Immobilien aus Insolvenzverfahren — Chancen für erfahrene Investoren.',
    },
    cover: img('1518621833791-591e1db3b7ce', 1400),
  },
];

export const PROPERTIES = [
  // ---------------- HOTELS ----------------
  {
    id: 'h1',
    category: 'hotels',
    ref: 'STK-H-2041',
    title: { fr: 'Palace en bord de mer', en: 'Seafront Palace' },
    location: { fr: 'Nice, Côte d’Azur', en: 'Nice, French Riviera' },
    country: 'France',
    price: 42000000,
    surface: 6800,
    keys: 92,
    images: [img('1683290844875-0eee4089069a'), img('1759038085950-1234ca8f5fed'), img('1551882547-ff40c63fe5fa')],
    excerpt: {
      fr: "Hôtel 5 étoiles de 92 clefs, spa, restaurant étoilé et vue mer panoramique.",
      en: '5-star hotel with 92 keys, spa, starred restaurant and panoramic sea views.',
    },
    description: {
      fr: "Institution emblématique de la Côte d’Azur, ce palace de 92 clefs allie architecture Belle Époque et prestations contemporaines. Spa de 900 m², restaurant gastronomique étoilé, plage privée et rooftop panoramique. Exploitation en pleine propriété, murs et fonds.",
      en: 'An iconic Riviera institution, this 92-key palace combines Belle Époque architecture with contemporary services. A 900 sqm spa, starred gastronomic restaurant, private beach and panoramic rooftop. Full freehold ownership, walls and business.',
    },
    features: { fr: ['92 clefs', 'Spa 900 m²', 'Plage privée', 'Restaurant étoilé', 'Rooftop'], en: ['92 keys', '900 sqm spa', 'Private beach', 'Starred restaurant', 'Rooftop'] },
  },
  {
    id: 'h2',
    category: 'hotels',
    ref: 'STK-H-2088',
    title: { fr: 'Hôtel de charme historique', en: 'Historic Boutique Hotel' },
    location: { fr: 'Genève, Suisse', en: 'Geneva, Switzerland' },
    country: 'Suisse',
    price: 28500000,
    surface: 3200,
    keys: 48,
    images: [img('1501525776-246410718e63'), img('1758193783649-13371d7fb8dd')],
    excerpt: {
      fr: 'Hôtel 4 étoiles de 48 chambres au cœur de Genève, forte rentabilité.',
      en: '48-room 4-star hotel in central Geneva with strong yield.',
    },
    description: {
      fr: "Au cœur de la rive droite, cet hôtel 4 étoiles de 48 chambres bénéficie d’un emplacement premium à quelques pas du lac. Rentabilité établie, rénovation récente et clientèle internationale fidèle.",
      en: 'In the heart of the right bank, this 48-room 4-star hotel enjoys a premium location steps from the lake. Established profitability, recent renovation and a loyal international clientele.',
    },
    features: { fr: ['48 chambres', 'Rénové 2023', 'Bar & lounge', 'Centre-ville'], en: ['48 rooms', 'Renovated 2023', 'Bar & lounge', 'City center'] },
  },
  {
    id: 'h3',
    category: 'hotels',
    ref: 'STK-H-2103',
    title: { fr: 'Resort de montagne', en: 'Alpine Mountain Resort' },
    location: { fr: 'Verbier, Valais', en: 'Verbier, Valais' },
    country: 'Suisse',
    price: 65000000,
    surface: 9400,
    keys: 120,
    images: [img('1445019980597-93fa8acb246c'), img('1551882547-ff40c63fe5fa')],
    excerpt: {
      fr: 'Resort 5 étoiles au pied des pistes, spa alpin et 120 clefs.',
      en: '5-star ski-in resort with alpine spa and 120 keys.',
    },
    description: {
      fr: "Resort 5 étoiles ski-in / ski-out au cœur de Verbier. 120 clefs, spa alpin de 1 200 m², plusieurs restaurants et espaces séminaires. Un actif rare sur l’un des domaines les plus prisés des Alpes.",
      en: 'Ski-in / ski-out 5-star resort in the heart of Verbier. 120 keys, 1,200 sqm alpine spa, several restaurants and seminar spaces. A rare asset in one of the most sought-after Alpine domains.',
    },
    features: { fr: ['120 clefs', 'Ski-in / ski-out', 'Spa alpin', 'Restaurants'], en: ['120 keys', 'Ski-in / ski-out', 'Alpine spa', 'Restaurants'] },
  },
  {
    id: 'h4',
    category: 'hotels',
    ref: 'STK-H-2117',
    title: { fr: 'Hôtel particulier hospitalier', en: 'Private Mansion Hotel' },
    location: { fr: 'Paris 8e', en: 'Paris 8th' },
    country: 'France',
    price: 54000000,
    surface: 4100,
    keys: 40,
    images: [img('1630756656892-878fcf4686d7'), img('1759038085950-1234ca8f5fed')],
    excerpt: {
      fr: "Hôtel 5 étoiles de 40 clefs dans un hôtel particulier du Triangle d’Or.",
      en: '40-key 5-star hotel in a mansion within the Golden Triangle.',
    },
    description: {
      fr: "Adresse confidentielle du Triangle d’Or, cet hôtel particulier transformé en établissement 5 étoiles offre 40 clefs, un patio verdoyant et un service sur-mesure. Emplacement d’exception à deux pas des Champs-Élysées.",
      en: 'A confidential Golden Triangle address, this private mansion converted into a 5-star establishment offers 40 keys, a leafy patio and bespoke service. Exceptional location steps from the Champs-Élysées.',
    },
    features: { fr: ['40 clefs', 'Triangle d’Or', 'Patio', 'Service sur-mesure'], en: ['40 keys', 'Golden Triangle', 'Patio', 'Bespoke service'] },
  },
  {
    id: 'h5',
    category: 'hotels',
    ref: 'STK-H-2129',
    title: { fr: 'Hôtel design contemporain', en: 'Contemporary Design Hotel' },
    location: { fr: 'Lyon, Presqu’île', en: 'Lyon, Presqu’île' },
    country: 'France',
    price: 19800000,
    surface: 2600,
    keys: 64,
    images: [img('1731446294563-e492c2a54dbc'), img('1758193783649-13371d7fb8dd')],
    excerpt: {
      fr: 'Hôtel 4 étoiles design de 64 chambres, rooftop bar tendance.',
      en: '64-room 4-star design hotel with a trendy rooftop bar.',
    },
    description: {
      fr: "Hôtel 4 étoiles au design contemporain signé, 64 chambres, rooftop bar prisé et forte notoriété locale. Emplacement central sur la Presqu’île lyonnaise.",
      en: 'A signature contemporary-design 4-star hotel, 64 rooms, popular rooftop bar and strong local reputation. Central location on the Lyon Presqu’île.',
    },
    features: { fr: ['64 chambres', 'Rooftop bar', 'Design', 'Hyper-centre'], en: ['64 rooms', 'Rooftop bar', 'Design', 'City center'] },
  },
  {
    id: 'h6',
    category: 'hotels',
    ref: 'STK-H-2140',
    title: { fr: 'Hôtel balnéaire international', en: 'International Seaside Hotel' },
    location: { fr: 'Marbella, Espagne', en: 'Marbella, Spain' },
    country: 'International',
    price: 78000000,
    surface: 12000,
    keys: 180,
    images: [img('1551882547-ff40c63fe5fa'), img('1445019980597-93fa8acb246c')],
    excerpt: {
      fr: 'Complexe 5 étoiles de 180 clefs, front de mer, golf et marina.',
      en: '180-key 5-star seafront resort with golf and marina.',
    },
    description: {
      fr: "Complexe hôtelier 5 étoiles de 180 clefs en front de mer, comprenant golf, marina privée, plusieurs piscines et un centre de bien-être. Un actif de rendement international majeur.",
      en: 'A 180-key 5-star seafront resort including golf, private marina, multiple pools and a wellness center. A major international yield asset.',
    },
    features: { fr: ['180 clefs', 'Golf', 'Marina', 'Front de mer'], en: ['180 keys', 'Golf', 'Marina', 'Seafront'] },
  },

  // ---------------- IMMEUBLES ----------------
  {
    id: 'i1',
    category: 'immeubles',
    ref: 'STK-I-3011',
    title: { fr: 'Immeuble haussmannien de prestige', en: 'Prestige Haussmann Building' },
    location: { fr: 'Paris 16e', en: 'Paris 16th' },
    country: 'France',
    price: 32000000,
    surface: 2400,
    units: 14,
    images: [img('1614349214089-e969a07e033b'), img('1657129208507-7005dfc5b36a')],
    excerpt: {
      fr: 'Immeuble haussmannien complet, 14 lots, pierre de taille.',
      en: 'Full Haussmann building, 14 units, cut-stone facade.',
    },
    description: {
      fr: "Immeuble haussmannien de rapport entièrement libéré, pierre de taille, 14 lots répartis sur 6 étages. Emplacement recherché du 16e arrondissement, fort potentiel de valorisation.",
      en: 'Fully vacant Haussmann income building, cut-stone facade, 14 units over 6 floors. Sought-after 16th arrondissement location with strong value-add potential.',
    },
    features: { fr: ['14 lots', '6 étages', 'Pierre de taille', 'Ascenseur'], en: ['14 units', '6 floors', 'Cut stone', 'Elevator'] },
  },
  {
    id: 'i2',
    category: 'immeubles',
    ref: 'STK-I-3024',
    title: { fr: 'Immeuble de rapport centre-ville', en: 'City-Center Income Building' },
    location: { fr: 'Bordeaux', en: 'Bordeaux' },
    country: 'France',
    price: 8900000,
    surface: 1650,
    units: 12,
    images: [img('1657129208507-7005dfc5b36a'), img('1711014347616-78e05a9c28d7')],
    excerpt: {
      fr: 'Immeuble de rapport loué, 12 appartements, rendement sécurisé.',
      en: 'Tenanted income building, 12 apartments, secured yield.',
    },
    description: {
      fr: "Immeuble de rapport entièrement loué au cœur de Bordeaux, 12 appartements du studio au T3. Rendement sécurisé, faible vacance, quartier en plein essor.",
      en: 'Fully tenanted income building in central Bordeaux, 12 apartments from studios to 3-rooms. Secured yield, low vacancy, thriving neighborhood.',
    },
    features: { fr: ['12 appartements', 'Loué', 'Centre-ville', 'Faible vacance'], en: ['12 apartments', 'Tenanted', 'City center', 'Low vacancy'] },
  },
  {
    id: 'i3',
    category: 'immeubles',
    ref: 'STK-I-3037',
    title: { fr: 'Immeuble mixte bureaux & commerces', en: 'Mixed-Use Office & Retail' },
    location: { fr: 'Genève, Suisse', en: 'Geneva, Switzerland' },
    country: 'Suisse',
    price: 46000000,
    surface: 4200,
    units: 20,
    images: [img('1670407203479-a4e2d7ffc616'), img('1726416040293-0ba2618b4f86')],
    excerpt: {
      fr: 'Immeuble mixte bureaux et commerces, baux long terme.',
      en: 'Mixed office and retail building, long-term leases.',
    },
    description: {
      fr: "Immeuble mixte de standing au centre de Genève : commerces en pied d’immeuble et plateaux de bureaux loués à des enseignes de premier plan. Baux long terme, revenus indexiés.",
      en: 'High-standing mixed-use building in central Geneva: ground-floor retail and office floors leased to blue-chip tenants. Long-term indexed leases.',
    },
    features: { fr: ['Bureaux', 'Commerces', 'Baux long terme', 'Centre-ville'], en: ['Offices', 'Retail', 'Long leases', 'City center'] },
  },
  {
    id: 'i4',
    category: 'immeubles',
    ref: 'STK-I-3049',
    title: { fr: 'Ensemble résidentiel neuf', en: 'New Residential Ensemble' },
    location: { fr: 'Lausanne, Suisse', en: 'Lausanne, Switzerland' },
    country: 'Suisse',
    price: 24500000,
    surface: 3100,
    units: 26,
    images: [img('1731446294563-e492c2a54dbc'), img('1705519616910-9ec8d59c3b51')],
    excerpt: {
      fr: 'Résidence neuve de 26 logements, normes énergétiques.',
      en: 'New residence of 26 homes, high energy standards.',
    },
    description: {
      fr: "Résidence neuve de 26 logements aux normes énergétiques Minergie, vue lac pour plusieurs lots. Livraison récente, aucune charge de travaux, idéal investisseur institutionnel.",
      en: 'New residence of 26 homes built to Minergie energy standards, lake views for several units. Recently delivered, no capex, ideal for institutional investors.',
    },
    features: { fr: ['26 logements', 'Minergie', 'Vue lac', 'Neuf'], en: ['26 homes', 'Minergie', 'Lake view', 'New build'] },
  },
  {
    id: 'i5',
    category: 'immeubles',
    ref: 'STK-I-3055',
    title: { fr: 'Immeuble d’angle pierre de taille', en: 'Corner Cut-Stone Building' },
    location: { fr: 'Paris 9e', en: 'Paris 9th' },
    country: 'France',
    price: 18700000,
    surface: 1900,
    units: 11,
    images: [img('1699787592432-8b54a9a1a868'), img('1518621833791-591e1db3b7ce')],
    excerpt: {
      fr: 'Immeuble d’angle, belle hauteur sous plafond, 11 lots.',
      en: 'Corner building, high ceilings, 11 units.',
    },
    description: {
      fr: "Immeuble d’angle en pierre de taille, belles hauteurs sous plafond, moulures et parquets d’origine. 11 lots à rafraîchir, fort potentiel dans un quartier très demandé.",
      en: 'Corner cut-stone building, generous ceiling heights, original mouldings and parquet. 11 units to refresh, strong potential in a highly sought neighborhood.',
    },
    features: { fr: ['11 lots', 'Angle', 'Moulures', 'À valoriser'], en: ['11 units', 'Corner', 'Mouldings', 'Value-add'] },
  },
  {
    id: 'i6',
    category: 'immeubles',
    ref: 'STK-I-3062',
    title: { fr: 'Immeuble contemporain international', en: 'International Contemporary Building' },
    location: { fr: 'Bruxelles, Belgique', en: 'Brussels, Belgium' },
    country: 'International',
    price: 39000000,
    surface: 5400,
    units: 30,
    images: [img('1726416040293-0ba2618b4f86'), img('1670407203479-a4e2d7ffc616')],
    excerpt: {
      fr: 'Immeuble tertiaire contemporain, certifié BREEAM.',
      en: 'Contemporary office building, BREEAM certified.',
    },
    description: {
      fr: "Immeuble tertiaire contemporain certifié BREEAM Excellent, quartier européen de Bruxelles. Locataire unique de premier rang, bail ferme longue durée.",
      en: 'Contemporary office building, BREEAM Excellent certified, in the European quarter of Brussels. Single blue-chip tenant, long firm lease.',
    },
    features: { fr: ['BREEAM', 'Bail ferme', 'Quartier européen', 'Tertiaire'], en: ['BREEAM', 'Firm lease', 'European quarter', 'Office'] },
  },

  // ---------------- BIENS D'EXCEPTION ----------------
  {
    id: 'e1',
    category: 'exception',
    ref: 'STK-E-4010',
    title: { fr: 'Villa contemporaine vue mer', en: 'Contemporary Sea-View Villa' },
    location: { fr: 'Saint-Jean-Cap-Ferrat', en: 'Saint-Jean-Cap-Ferrat' },
    country: 'France',
    price: 29500000,
    surface: 720,
    bedrooms: 6,
    images: [img('1580587771525-78b9dba3b914'), img('1600596542815-ffad4c1539a9')],
    excerpt: {
      fr: 'Villa d’architecte, piscine à débordement, vue mer à 180°.',
      en: 'Architect villa, infinity pool, 180° sea views.',
    },
    description: {
      fr: "Villa d’architecte contemporaine sur l’une des presqu’îles les plus prisées au monde. 720 m², 6 chambres en suite, piscine à débordement, jardin méditerranéen et accès mer. Vue à 180° sur la Grande Bleue.",
      en: 'Contemporary architect villa on one of the world’s most coveted peninsulas. 720 sqm, 6 en-suite bedrooms, infinity pool, Mediterranean garden and sea access. 180° views over the sea.',
    },
    features: { fr: ['6 chambres', 'Piscine à débordement', 'Vue mer 180°', 'Accès mer'], en: ['6 bedrooms', 'Infinity pool', '180° sea view', 'Sea access'] },
  },
  {
    id: 'e2',
    category: 'exception',
    ref: 'STK-E-4023',
    title: { fr: 'Château viticole', en: 'Vineyard Chateau' },
    location: { fr: 'Saint-Émilion', en: 'Saint-Émilion' },
    country: 'France',
    price: 21000000,
    surface: 1400,
    bedrooms: 12,
    images: [img('1613490493576-7fde63acd811'), img('1630891363774-8f4de5beaeae')],
    excerpt: {
      fr: 'Château du XVIIIe, domaine viticole classé, 40 hectares.',
      en: '18th-century chateau, classified vineyard, 40 hectares.',
    },
    description: {
      fr: "Château du XVIIIe siècle au cœur d’un domaine viticole classé de 40 hectares. Chais, dépendances, parc à la française et 12 chambres. Une propriété d’exception allégeant art de vivre et actif viticole.",
      en: '18th-century chateau at the heart of a 40-hectare classified vineyard. Cellars, outbuildings, French formal park and 12 bedrooms. An exceptional property blending art de vivre and wine estate.',
    },
    features: { fr: ['40 hectares', 'Chais', '12 chambres', 'Parc'], en: ['40 hectares', 'Cellars', '12 bedrooms', 'Park'] },
  },
  {
    id: 'e3',
    category: 'exception',
    ref: 'STK-E-4035',
    title: { fr: 'Propriété au bord du lac', en: 'Lakeside Estate' },
    location: { fr: 'Montreux, Suisse', en: 'Montreux, Switzerland' },
    country: 'Suisse',
    price: 34000000,
    surface: 950,
    bedrooms: 7,
    images: [img('1692192811731-72d5ac291948'), img('1630891363774-8f4de5beaeae')],
    excerpt: {
      fr: 'Propriété pieds dans l’eau, ponton privé, vue Alpes.',
      en: 'Waterfront estate, private pontoon, Alpine views.',
    },
    description: {
      fr: "Propriété d’exception les pieds dans l’eau sur la Riviera vaudoise. Ponton privé, parc arboré, 7 chambres et vue imprenable sur le lac Léman et les Alpes. Rarissime sur le marché.",
      en: 'Exceptional waterfront estate on the Vaud Riviera. Private pontoon, mature park, 7 bedrooms and breathtaking views over Lake Geneva and the Alps. Extremely rare to market.',
    },
    features: { fr: ['Pieds dans l’eau', 'Ponton privé', '7 chambres', 'Vue Alpes'], en: ['Waterfront', 'Private pontoon', '7 bedrooms', 'Alps view'] },
  },
  {
    id: 'e4',
    category: 'exception',
    ref: 'STK-E-4048',
    title: { fr: 'Penthouse panoramique', en: 'Panoramic Penthouse' },
    location: { fr: 'Paris 7e', en: 'Paris 7th' },
    country: 'France',
    price: 16800000,
    surface: 380,
    bedrooms: 4,
    images: [img('1600596542815-ffad4c1539a9'), img('1670589953882-b94c9cb380f5')],
    excerpt: {
      fr: 'Penthouse dernier étage, terrasse, vue Tour Eiffel.',
      en: 'Top-floor penthouse, terrace, Eiffel Tower view.',
    },
    description: {
      fr: "Penthouse de 380 m² au dernier étage d’un immeuble d’exception, vaste terrasse avec vue directe sur la Tour Eiffel. 4 chambres, prestations haut de gamme, double exposition.",
      en: '380 sqm top-floor penthouse in an exceptional building, vast terrace with a direct Eiffel Tower view. 4 bedrooms, high-end finishes, double exposure.',
    },
    features: { fr: ['Terrasse', 'Vue Tour Eiffel', '4 chambres', 'Dernier étage'], en: ['Terrace', 'Eiffel view', '4 bedrooms', 'Top floor'] },
  },
  {
    id: 'e5',
    category: 'exception',
    ref: 'STK-E-4059',
    title: { fr: 'Manoir moderne d’architecte', en: 'Modern Architect Manor' },
    location: { fr: 'Gstaad, Suisse', en: 'Gstaad, Switzerland' },
    country: 'Suisse',
    price: 48000000,
    surface: 1100,
    bedrooms: 8,
    images: [img('1505843513577-22bb7d21e455'), img('1670589953882-b94c9cb380f5')],
    excerpt: {
      fr: 'Chalet-manoir contemporain, spa, cinéma, ski-room.',
      en: 'Contemporary chalet-manor, spa, cinema, ski-room.',
    },
    description: {
      fr: "Chalet-manoir contemporain sur les hauteurs de Gstaad. 1 100 m², 8 chambres, spa privé, salle de cinéma, ski-room et vue panoramique sur les Alpes bernoises. L’art de vivre alpin dans sa version la plus aboutie.",
      en: 'Contemporary chalet-manor above Gstaad. 1,100 sqm, 8 bedrooms, private spa, cinema room, ski-room and panoramic views over the Bernese Alps. Alpine art de vivre at its finest.',
    },
    features: { fr: ['8 chambres', 'Spa privé', 'Cinéma', 'Ski-room'], en: ['8 bedrooms', 'Private spa', 'Cinema', 'Ski-room'] },
  },
  {
    id: 'e6',
    category: 'exception',
    ref: 'STK-E-4067',
    title: { fr: 'Villa d’architecte internationale', en: 'International Architect Villa' },
    location: { fr: 'Ibiza, Espagne', en: 'Ibiza, Spain' },
    country: 'International',
    price: 22000000,
    surface: 640,
    bedrooms: 6,
    images: [img('1613490493576-7fde63acd811'), img('1580587771525-78b9dba3b914')],
    excerpt: {
      fr: 'Villa design pieds dans l’eau, coucher de soleil.',
      en: 'Waterfront design villa, sunset facing.',
    },
    description: {
      fr: "Villa design pieds dans l’eau, exposée plein ouest pour des couchers de soleil spectaculaires. 6 chambres, piscine à débordement, accès mer privé. Signature architecturale contemporaine.",
      en: 'Waterfront design villa, west-facing for spectacular sunsets. 6 bedrooms, infinity pool, private sea access. Contemporary architectural signature.',
    },
    features: { fr: ['6 chambres', 'Pieds dans l’eau', 'Coucher de soleil', 'Piscine'], en: ['6 bedrooms', 'Waterfront', 'Sunset facing', 'Pool'] },
  },

  // ---------------- LIQUIDATION JUDICIAIRE ----------------
  {
    id: 'l1',
    category: 'liquidation',
    ref: 'STK-L-5010',
    title: { fr: 'Hôtel en liquidation judiciaire', en: 'Hotel in Judicial Liquidation' },
    location: { fr: 'Cannes', en: 'Cannes' },
    country: 'France',
    price: 12500000,
    surface: 3400,
    status: { fr: 'Procédure en cours', en: 'Procedure ongoing' },
    images: [img('1630756656892-878fcf4686d7'), img('1683290844875-0eee4089069a')],
    excerpt: {
      fr: 'Hôtel 4 étoiles cédé dans le cadre d’une procédure collective.',
      en: '4-star hotel sold within an insolvency procedure.',
    },
    description: {
      fr: "Hôtel 4 étoiles cédé dans le cadre d’une liquidation judiciaire. Emplacement de premier ordre à Cannes, potentiel de repositionnement important. Vente sous supervision du mandataire, dossier remis sur demande.",
      en: '4-star hotel sold within a judicial liquidation. Prime location in Cannes, significant repositioning potential. Sale under receiver supervision, file available on request.',
    },
    features: { fr: ['Prix décoté', 'Repositionnement', 'Mandataire', 'Emplacement premium'], en: ['Discounted price', 'Repositioning', 'Receiver', 'Prime location'] },
  },
  {
    id: 'l2',
    category: 'liquidation',
    ref: 'STK-L-5021',
    title: { fr: 'Immeuble de bureaux décoté', en: 'Discounted Office Building' },
    location: { fr: 'Marseille', en: 'Marseille' },
    country: 'France',
    price: 5400000,
    surface: 2800,
    status: { fr: 'Offres attendues', en: 'Offers awaited' },
    images: [img('1670407203479-a4e2d7ffc616'), img('1726416040293-0ba2618b4f86')],
    excerpt: {
      fr: 'Immeuble tertiaire vendu décoté, procédure collective.',
      en: 'Office building sold at a discount, insolvency procedure.',
    },
    description: {
      fr: "Immeuble tertiaire de 2 800 m² vendu à prix décoté dans le cadre d’une procédure collective. Travaux de remise à niveau à prévoir, fort potentiel locatif après rénovation.",
      en: '2,800 sqm office building sold at a discount within an insolvency procedure. Upgrade works required, strong rental potential after renovation.',
    },
    features: { fr: ['Prix décoté', 'À rénover', 'Fort potentiel', 'Procédure'], en: ['Discounted', 'To renovate', 'High potential', 'Procedure'] },
  },
  {
    id: 'l3',
    category: 'liquidation',
    ref: 'STK-L-5033',
    title: { fr: 'Résidence de tourisme', en: 'Tourism Residence' },
    location: { fr: 'Chamonix', en: 'Chamonix' },
    country: 'France',
    price: 8200000,
    surface: 2100,
    status: { fr: 'Procédure en cours', en: 'Procedure ongoing' },
    images: [img('1445019980597-93fa8acb246c'), img('1731446294563-e492c2a54dbc')],
    excerpt: {
      fr: 'Résidence de tourisme en montagne, actif en procédure.',
      en: 'Mountain tourism residence, asset under procedure.',
    },
    description: {
      fr: "Résidence de tourisme de 42 lots au cœur de Chamonix, cédée dans le cadre d’une liquidation judiciaire. Emplacement exceptionnel face au Mont-Blanc, forte demande locative saisonnière.",
      en: '42-unit tourism residence in the heart of Chamonix, sold within a judicial liquidation. Exceptional location facing Mont Blanc, strong seasonal rental demand.',
    },
    features: { fr: ['42 lots', 'Face Mont-Blanc', 'Prix décoté', 'Saisonnier'], en: ['42 units', 'Mont Blanc view', 'Discounted', 'Seasonal'] },
  },
  {
    id: 'l4',
    category: 'liquidation',
    ref: 'STK-L-5044',
    title: { fr: 'Immeuble mixte à restructurer', en: 'Mixed Building to Restructure' },
    location: { fr: 'Toulouse', en: 'Toulouse' },
    country: 'France',
    price: 3900000,
    surface: 1750,
    status: { fr: 'Offres attendues', en: 'Offers awaited' },
    images: [img('1705519616910-9ec8d59c3b51'), img('1699787592432-8b54a9a1a868')],
    excerpt: {
      fr: 'Immeuble mixte à restructurer, opportunité rare.',
      en: 'Mixed building to restructure, rare opportunity.',
    },
    description: {
      fr: "Immeuble mixte commerces et logements à restructurer entièrement, vendu dans le cadre d’une procédure collective. Emplacement central à Toulouse, marge de valorisation significative.",
      en: 'Mixed retail and residential building to fully restructure, sold within an insolvency procedure. Central Toulouse location, significant value-add margin.',
    },
    features: { fr: ['À restructurer', 'Mixte', 'Central', 'Forte marge'], en: ['To restructure', 'Mixed-use', 'Central', 'High margin'] },
  },
];

export const localize = (field, lang) => {
  if (field == null) return '';
  if (typeof field === 'string') return field;
  return field[lang] || field.fr || '';
};

export const formatPrice = (value, lang) => {
  const locale = lang === 'en' ? 'en-US' : 'fr-FR';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(value);
};
